/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActiveThemeDto,
  BrandingTicketDto,
  CreateThemeCommand,
  GetApiV1ThemesBrandingParams,
  GetApiV1ThemesParams,
  PresignBrandingCommand,
  ProblemDetails,
  ThemeDto,
  ThemeSummaryDtoPagedList,
  UpdateThemeRequest
} from '.././model';

import { request } from '../../http-client';




export const getApiV1ThemeActive = (
    
 signal?: AbortSignal
) => {
      
      
      return request<ActiveThemeDto>(
      {url: `/api/v1/theme/active`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1ThemeActiveQueryKey = () => {
    return [
    `/api/v1/theme/active`
    ] as const;
    }

    
export const getGetApiV1ThemeActiveQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError = void | ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ThemeActiveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ThemeActive>>> = ({ signal }) => getApiV1ThemeActive(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ThemeActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThemeActive>>>
export type GetApiV1ThemeActiveQueryError = void | ProblemDetails


export function useGetApiV1ThemeActive<TData = Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError = void | ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemeActive>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemeActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemeActive<TData = Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError = void | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemeActive>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemeActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemeActive<TData = Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError = void | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ThemeActive<TData = Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError = void | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemeActive>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ThemeActiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1Themes = (
    params?: GetApiV1ThemesParams,
 signal?: AbortSignal
) => {
      
      
      return request<ThemeSummaryDtoPagedList>(
      {url: `/api/v1/themes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1ThemesQueryKey = (params?: GetApiV1ThemesParams,) => {
    return [
    `/api/v1/themes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1ThemesQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Themes>>, TError = unknown>(params?: GetApiV1ThemesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ThemesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Themes>>> = ({ signal }) => getApiV1Themes(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ThemesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Themes>>>
export type GetApiV1ThemesQueryError = unknown


export function useGetApiV1Themes<TData = Awaited<ReturnType<typeof getApiV1Themes>>, TError = unknown>(
 params: undefined |  GetApiV1ThemesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Themes>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Themes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Themes<TData = Awaited<ReturnType<typeof getApiV1Themes>>, TError = unknown>(
 params?: GetApiV1ThemesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Themes>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Themes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Themes<TData = Awaited<ReturnType<typeof getApiV1Themes>>, TError = unknown>(
 params?: GetApiV1ThemesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Themes<TData = Awaited<ReturnType<typeof getApiV1Themes>>, TError = unknown>(
 params?: GetApiV1ThemesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Themes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ThemesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1Themes = (
    createThemeCommand: CreateThemeCommand,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/themes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createThemeCommand, signal
    },
      );
    }
  


export const getPostApiV1ThemesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Themes>>, TError,{data: CreateThemeCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Themes>>, TError,{data: CreateThemeCommand}, TContext> => {

const mutationKey = ['postApiV1Themes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Themes>>, {data: CreateThemeCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Themes(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ThemesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Themes>>>
    export type PostApiV1ThemesMutationBody = CreateThemeCommand
    export type PostApiV1ThemesMutationError = ProblemDetails

    export const usePostApiV1Themes = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Themes>>, TError,{data: CreateThemeCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Themes>>,
        TError,
        {data: CreateThemeCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1ThemesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1ThemesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return request<ThemeDto>(
      {url: `/api/v1/themes/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1ThemesIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/themes/${id}`
    ] as const;
    }

    
export const getGetApiV1ThemesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ThemesId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ThemesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ThemesId>>> = ({ signal }) => getApiV1ThemesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ThemesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThemesId>>>
export type GetApiV1ThemesIdQueryError = ProblemDetails


export function useGetApiV1ThemesId<TData = Awaited<ReturnType<typeof getApiV1ThemesId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemesId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemesId<TData = Awaited<ReturnType<typeof getApiV1ThemesId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemesId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemesId<TData = Awaited<ReturnType<typeof getApiV1ThemesId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ThemesId<TData = Awaited<ReturnType<typeof getApiV1ThemesId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ThemesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiV1ThemesId = (
    id: string,
    updateThemeRequest: UpdateThemeRequest,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/themes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateThemeRequest
    },
      );
    }
  


export const getPutApiV1ThemesIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ThemesId>>, TError,{id: string;data: UpdateThemeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1ThemesId>>, TError,{id: string;data: UpdateThemeRequest}, TContext> => {

const mutationKey = ['putApiV1ThemesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1ThemesId>>, {id: string;data: UpdateThemeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV1ThemesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1ThemesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1ThemesId>>>
    export type PutApiV1ThemesIdMutationBody = UpdateThemeRequest
    export type PutApiV1ThemesIdMutationError = ProblemDetails

    export const usePutApiV1ThemesId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1ThemesId>>, TError,{id: string;data: UpdateThemeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1ThemesId>>,
        TError,
        {id: string;data: UpdateThemeRequest},
        TContext
      > => {

      const mutationOptions = getPutApiV1ThemesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1ThemesBranding = (
    presignBrandingCommand: PresignBrandingCommand,
 signal?: AbortSignal
) => {
      
      
      return request<BrandingTicketDto>(
      {url: `/api/v1/themes/branding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: presignBrandingCommand, signal
    },
      );
    }
  


export const getPostApiV1ThemesBrandingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesBranding>>, TError,{data: PresignBrandingCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesBranding>>, TError,{data: PresignBrandingCommand}, TContext> => {

const mutationKey = ['postApiV1ThemesBranding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ThemesBranding>>, {data: PresignBrandingCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1ThemesBranding(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ThemesBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThemesBranding>>>
    export type PostApiV1ThemesBrandingMutationBody = PresignBrandingCommand
    export type PostApiV1ThemesBrandingMutationError = ProblemDetails

    export const usePostApiV1ThemesBranding = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesBranding>>, TError,{data: PresignBrandingCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ThemesBranding>>,
        TError,
        {data: PresignBrandingCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1ThemesBrandingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1ThemesBranding = (
    params?: GetApiV1ThemesBrandingParams,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/themes/branding`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1ThemesBrandingQueryKey = (params?: GetApiV1ThemesBrandingParams,) => {
    return [
    `/api/v1/themes/branding`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1ThemesBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError = ProblemDetails>(params?: GetApiV1ThemesBrandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1ThemesBrandingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1ThemesBranding>>> = ({ signal }) => getApiV1ThemesBranding(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1ThemesBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1ThemesBranding>>>
export type GetApiV1ThemesBrandingQueryError = ProblemDetails


export function useGetApiV1ThemesBranding<TData = Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError = ProblemDetails>(
 params: undefined |  GetApiV1ThemesBrandingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemesBranding>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemesBranding>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemesBranding<TData = Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError = ProblemDetails>(
 params?: GetApiV1ThemesBrandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1ThemesBranding>>,
          TError,
          Awaited<ReturnType<typeof getApiV1ThemesBranding>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1ThemesBranding<TData = Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError = ProblemDetails>(
 params?: GetApiV1ThemesBrandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1ThemesBranding<TData = Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError = ProblemDetails>(
 params?: GetApiV1ThemesBrandingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1ThemesBranding>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1ThemesBrandingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1ThemesIdActivate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/themes/${id}/activate`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1ThemesIdActivateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiV1ThemesIdActivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiV1ThemesIdActivate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ThemesIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>>
    
    export type PostApiV1ThemesIdActivateMutationError = ProblemDetails

    export const usePostApiV1ThemesIdActivate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ThemesIdActivate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1ThemesIdActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    